var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-card-body',_vm._l((_vm.data),function(v,vi){return _c('ul',{key:vi},[_c('li',[_vm._v(_vm._s(v.name)+" - "+_vm._s(v.value))])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }